import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { serialize } from "object-to-formdata";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import * as actions from "../../store/profile/actions";
import * as authActions from "../../store/authentication/actions";
import { ButtonComponent } from "../../components/Controls/Button/Button";
import InputField from "../../components/Controls/Input/Input";
import DialogComponent from "../../components/Dialog/Dialog";
import OTP from "../Auth/OTPForm/OTP";
import ResetPassword from "../Auth/ResetPassword/ResetPassword";
import "./profile.scss";
import { userAvatar } from '../../utils/images';

const Profile = ({ intl: { messages } }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.auth?.user?.data);
  const { reset_token, reset_password_success } = useSelector(
    (state) => state.auth
  );
  const { update_profile_img_success_msg } = useSelector(
    (state) => state.profile
  );
  const [cancel, setCancel] = useState(false);
  const expirationDate = localStorage.getItem("expirationDate");
  const [editProfile, setEditProfile] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [uploadedImage, setUploadedImage] = useState({
    file: "",
    fileName: "",
    fileSize: "",
    fileType: "",
  });
  const [imageErrors, setImageErrors] = useState({
    typeErr: false,
    sizeErr: false,
  });
  const fileSize = 1;

  const onFileChange = (event) => {
    setImageErrors({ typeErr: false, sizeErr: false });
    setUploadedImage({
      file: event.target.files[0],
      fileName: event.target.files[0]?.name,
      fileSize: event.target.files[0]?.size, //size in bytes
      fileType: event.target.files[0]?.type,
    });
    checkSelectedFileValidation(event);
  };
  const checkSelectedFileValidation = (event) => {
    if (event.target.files[0]) {
      setImageErrors({
        sizeErr: event.target.files[0].size / 1024 / 1024 > fileSize,
        msg:
          event.target.files[0].size / 1024 / 1024 > fileSize
            ? messages.errors.imageSizeErr
            : "",
      });
      if (event.target.files[0].size / 1024 / 1024 < fileSize) {
        viewImageHandler(event.target.files[0]);
      }
    }
  };

  const cancelChangeImage = () => {
    setEditProfile(false);
    setImageErrors({ typeErr: false, sizeErr: false });
    setUploadedImage({
      file: "",
      fileName: "",
      fileSize: "",
      fileType: "",
    });
    setSelectedImage("");
  };

  const viewImageHandler = (file) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      setSelectedImage(e.target.result);
    };
  };

  const handleUpdateImg = () => {
    if (uploadedImage?.file) {
      const userImg = document.getElementById("image")?.files[0];
      const formData = serialize({});
      formData.append("profile_image", userImg);
      dispatch(actions.editProfileImageRequest(formData));
    }
  };

  const handleClose = () => {
    setChangePassword(false);
    localStorage.removeItem("todo");
    dispatch(authActions.forgetPasswordReceive(null));
    setCancel(false);
  };

  const handleCancelChangePassword = () => {
    setCancel(true);
  };

  useEffect(() => {
    if (update_profile_img_success_msg) {
      dispatch(authActions.getUserRequest());
      setEditProfile(false);
      dispatch(actions.editProfileImageReceive(null));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update_profile_img_success_msg]);

  useEffect(() => {
    if (reset_password_success) {
      dispatch(authActions.logoutRequest({ reset_password: true }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset_password_success]);

  const renderCancelContent = () => {
    return (
      <div className="d-flex flex-column align-items-center mx-5 my-3">
        <WarningRoundedIcon style={{ color: "#faceb2", fontSize: "6rem" }} />
        <h4 className="">{messages.profile.cancelChangePasswordMSGHeader}</h4>
        <p className="">{messages.profile.cancelChangePasswordMSGContent}</p>
        <div className="d-flex justify-content-center">
          <ButtonComponent
            content={messages.common.confirm}
            variant="contained"
            classes="mx-2 px-5 my-3 form-submit-btn"
            handleClick={handleClose}
            color="primary"
          />
          <ButtonComponent
            content={messages.common.back}
            variant="outlined"
            classes="mx-2 px-5 my-3 form-submit-btn"
            handleClick={() => setCancel(false)}
            color="primary"
          />
        </div>
      </div>
    );
  };

  return (
    <section className="profile-wrapper">
      <h6 className="profile-wrapper_header mb-0">{messages.profile.header}</h6>
      <div className="profile-wrapper_personal-data">
        <div className="profile-wrapper_personal-data_img">
          {editProfile && (
            <>
              <input
                accept="image/*"
                className="d-none"
                id="image"
                type="file"
                onChange={(e) => onFileChange(e)}
              />
              <label
                htmlFor="image"
                className="profile-wrapper_personal-data_upload-btn"
              >
                <IconButton aria-label="upload picture" component="span">
                  <EditIcon className="profile-wrapper_personal-data_upload-btn_icon" />
                </IconButton>
              </label>
            </>
          )}
          <img
            src={
              selectedImage
                ? selectedImage
                : user?.profile_image ? `${process.env.REACT_APP_BASE_URL}${user?.profile_image}` : userAvatar
            }
            alt="profile"
          />
        </div>
        <h6 className="profile-wrapper_personal-data_name">{user?.name}</h6>
        <p className="profile-wrapper_personal-data_code">
          <span>{messages.profile.code}</span>
          <span>{user?.username}</span>
        </p>
      </div>
      <div className="profile-wrapper_details">
        <div className="row">
          <InputField
            id="role"
            name="role"
            label={messages.profile.job}
            value={user?.role_name}
            disabled={true}
            className="col-md-4 mx-4"
          />
          <InputField
            id="phone"
            name="phone"
            label={messages.profile.mobile}
            value={user?.phone_number}
            disabled={true}
            className="col-md-4"
          />
        </div>
        <div className="row">
          <InputField
            id="password"
            name="password"
            label={messages.auth.labels.password}
            value={user?.role_name}
            type="password"
            disabled={true}
            className="col-md-4 mx-4"
          />
          {editProfile && (
            <ButtonComponent
              content={messages.common.change}
              variant="outlined"
              classes="px-4 py-2 form-submit-btn change-btn mb-3"
              handleClick={() => {
                if (new Date(expirationDate).getTime() < new Date().getTime()) {
                  dispatch(
                    authActions.resendOTPRequest({
                      username: user?.username,
                      location: "profile",
                    })
                  );
                }
                setChangePassword(true);
                localStorage.setItem("todo", "reset_password");
              }}
              color="primary"
            />
          )}
        </div>
        <div className="row flex-row-reverse px-5">
          {editProfile ? (
            <>
              <ButtonComponent
                content={messages.common.cancel}
                variant="outlined"
                classes="px-4 py-2 form-submit-btn"
                handleClick={cancelChangeImage}
                color="primary"
              />
              <ButtonComponent
                content={messages.common.save}
                variant="contained"
                classes="px-4 py-2 mx-3 form-submit-btn"
                handleClick={() => {
                  handleUpdateImg();
                }}
                color="primary"
              />
            </>
          ) : (
            <ButtonComponent
              content={messages.profile.editInfo}
              variant="contained"
              classes="px-4 py-2 form-submit-btn"
              handleClick={() => setEditProfile(true)}
              color="primary"
            />
          )}
        </div>
      </div>

      {/* render edit image dialog */}
      <DialogComponent
        open={changePassword}
        handleClose={handleClose}
        content={
          reset_token && !cancel ? (
            <ResetPassword
              inDialog={true}
              handleCancel={handleCancelChangePassword}
            />
          ) : cancel ? (
            renderCancelContent()
          ) : (
            <OTP inDialog={true} handleCancel={handleClose} />
          )
        }
      />
    </section>
  );
};

export default injectIntl(Profile);
